$(document).ready(function()
{

    if ( $('#BackToTop').length )
    {

        $(window).scroll(function() {
            var height = $(window).scrollTop();
            if (height > 200) {
                $('#BackToTop').fadeIn();
            } else {
                $('#BackToTop').fadeOut();
            }
        });
        $(document).ready(function() {
            $("#BackToTop").click(function(event) {
                event.preventDefault();
                $("html, body").animate({ scrollTop: 0 }, "slow");
                return false;
            });

        });

    }
});